import { useTranslation } from "react-i18next";

export function AudienceTitle({audience}) {
    const { t } = useTranslation();

    return (
        <>{audience.title ? audience.title : t('AudienceType.' + audience.type)}</>
    )

}